import React from 'react';
import { Title, Panel, fmtDate } from '../bb/bbShared';

const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
const tone = (e) => (e == null ? 'text-slate-400' : e >= 0 ? 'text-[#1F6B35]' : 'text-[#A1281D]');

export const PiEcart = ({ ec }) => {
  if (!ec) return null;
  const [m, y] = ec.mois.split('/');
  return (
    <Panel testId="pi-ecart">
      <Title className="text-xl mb-1">Écart prévu / réalisé</Title>
      <p className="text-xs text-slate-500 mb-3">Projections retenues au point du {fmtDate(ec.date_point_precedent)}, comparées aux signatures réelles de {MOIS[Number(m) - 1]} {y}{ec.mois === `${String(new Date().getMonth() + 1).padStart(2, '0')}/${new Date().getFullYear()}` ? ' (mois en cours : résultat partiel)' : ''}.</p>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-[0.1em] text-slate-500 border-b">{['Type', 'Prévu', 'Réalisé', 'Écart'].map(h => <th key={h} className="py-2 pr-3">{h}</th>)}</tr></thead>
        <tbody>{ec.lignes.map(l => (
          <tr key={l.type} className="border-b border-[#EEECE8]" data-testid={`pi-ecart-${l.type}`}>
            <td className="py-2 pr-3 font-semibold">{l.type}</td>
            <td className="pr-3">{l.prevu ?? <span className="text-slate-400">non renseigné</span>}</td>
            <td className="pr-3">{l.realise}</td>
            <td className={`pr-3 font-bold ${tone(l.ecart)}`}>{l.ecart == null ? '—' : l.ecart > 0 ? `+${l.ecart}` : l.ecart}</td>
          </tr>))}</tbody>
      </table>
    </Panel>
  );
};
